<template>
  <section class="section container">
    <div class="container mt-0 mb-6">
      <h1 class="title is-4 mb-3 is-pulled-right">
        {{ $t("sales") }}
      </h1>
    </div>
    <div class="columns">
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("date range") }}</label>
          <generic-calendar
            type="date"
            :is_range="true"
            ref="generic_calendar"
            @selected="date_changed"
          />
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("query") }}</label>
          <div class="control">
            <button class="button is-rounded is-primary" @click="query">
              <span class="icon"><i class="fa fa-bolt"></i></span>
              <span>{{ $t("query") }}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <h1 class="title is-4 mb-3">
        {{ $t("total sold") }}: {{ format_currency(total_sold) }}
      </h1>
      <div>
        <!-- <pre>{{ sales }}</pre> -->
        <h1 class="title is-4 mb-6">
          <span
            class="pr-4"
            v-for="(p, pidx) in Object.keys(payment_summary)"
            :key="pidx"
          >
            {{ p }}: {{ format_currency(payment_summary[p]) }}
          </span>
        </h1>
        <!-- <pre>{{ payment_summary }}</pre> -->
        <div v-for="(sale, sidx) in sales" :key="sidx" class="mb-6">
          <div class="columns">
            <div class="column">
              <h1 class="title is-4 mb-3">
                {{ $t("sale") }}: {{ format_date_time(sale.create_date) }}
              </h1>
            </div>
            <div class="column">
              <h1 class="title is-4 mb-3">
                {{ $t("total") }}: {{ format_currency(sale.total) }}
              </h1>
            </div>
            <div class="column">
              <h1 class="title is-4 mb-3">
                <span
                  class="pr-4"
                  v-for="(p, pidx) in sale.payment"
                  :key="pidx"
                >
                  {{ p.name }}: {{ format_currency(p.amount) }}
                </span>
              </h1>
            </div>
            <div class="column" v-if="sale.bill">
              <h1 class="title is-5 mb-3">
                <span>
                  {{ $t("authorization") }}: {{ $t("series") }}
                  {{
                    sale.bill.response_data["dte:GTDocumento"]["dte:SAT"][0][
                      "dte:DTE"
                    ][0]["dte:Certificacion"][0]["dte:NumeroAutorizacion"][0][
                      "$"
                    ].Serie
                  }}, {{ $t("number") }}
                  {{
                    sale.bill.response_data["dte:GTDocumento"]["dte:SAT"][0][
                      "dte:DTE"
                    ][0]["dte:Certificacion"][0]["dte:NumeroAutorizacion"][0][
                      "$"
                    ].Numero
                  }}
                </span>
              </h1>
            </div>
          </div>
          <table class="table is-fullwidth">
            <thead>
              <tr>
                <th>{{ $t("product") }}</th>
                <th>{{ $t("sale price") }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(sp, spidx) in sale.sale_products" :key="spidx">
                <td>{{ sp.product.name }}</td>
                <td>{{ format_currency(sp.sale_price) }}</td>
              </tr>
            </tbody>
          </table>
          <!-- <pre>{{ sale }}</pre> -->
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import {
  get,
  generate_datatables_buttons,
  error_message,
  put,
  del,
  confirm_deletion_dialog,
  success_message,
  format_date_time,
  format_time,
  format_currency,
} from "@/utils";
import GenericTable from "@/components/generic_table/GenericTable.vue";
import GenericCalendar from "@/components/generic_calendar/Index.vue";

export default {
  name: "SalesReport",
  components: { GenericTable, GenericCalendar },
  data() {
    let v = this;
    return {
      sales: [],
      meta: {
        start_date: "",
        end_date: "",
      },
    };
  },
  computed: {
    total_sold() {
      let v = this;
      let total = v.sales.reduce((acc, sale) => {
        return acc + Number(sale.total);
      }, 0);
      return total;
    },
    payment_summary() {
      let v = this;
      if (v.sales.length) {
        let summary = v.sales.reduce((acc, sale) => {
          let payment = sale.payment;
          payment.map((p) => {
            if (acc[p.name]) {
              acc[p.name] += Number(p.amount);
            } else {
              acc[p.name] = Number(p.amount);
            }
          });
          return acc;
        }, {});
        return summary;
      } else return {};
    },
  },
  methods: {
    format_date_time,
    format_time,
    format_currency,
    query() {
      let v = this;
      get("/apis/sale/date-range", v.meta)
        .then((r) => {
          v.sales = r;
        })
        .catch((error) => {
          error_message(error);
        });
    },
    date_changed(date) {
      let v = this;
      v.meta.start_date = date.start_date;
      v.meta.end_date = date.end_date;
    },
  },
  mounted() {
    let v = this;

    // get("/apis/system/users", {})
    //   .then((r) => {
    //     v.users = r;

    //     setTimeout(() => {
    //       // // To access to bulmaCalendar instance of an element
    //       // var element = document.querySelector("#my-element");
    //       // if (element) {
    //       //   // bulmaCalendar instance is available as element.bulmaCalendar
    //       //   element.bulmaCalendar.on("select", function (datepicker) {
    //       //     console.log(datepicker.data.value());
    //       //   });
    //       // }
    //     }, 200);
    //   })
    //   .catch((error) => {
    //     error_message(error);
    //   });
  },
};
</script>

<style>
/* Add Bulma styles here */
</style>
